/** Visit coverage keeps its legacy URL, but owns a separate Work destination. */
export const isVisitCoveragePath = (pathname: string): boolean =>
  pathname === '/staff/visit-offers' || pathname.startsWith('/staff/visit-offers/');

export function isCurrentPath(pathname: string, to: string): boolean {
  if (to === '/staff' && isVisitCoveragePath(pathname)) return false;
  return pathname === to || pathname.startsWith(`${to}/`);
}

/**
 * The Help page, however the router was asked for it: React Router matches
 * `/help` ignoring trailing slashes and letter case, so a bookmarked `/help/`
 * is the same page and must get the same treatment (no lock screen, not saved
 * as the page Help was opened from).
 */
export const isHelpPath = (pathname: string): boolean => pathname.replace(/\/+$/, '').toLowerCase() === '/help';

/**
 * Which of a navigation's destinations the page belongs to: the most specific
 * one it sits under, so `/staff/visit-offers` is Visit coverage's page and not
 * also Staff's. `null` when it is under none of them.
 */
export function currentNavPath(pathname: string, paths: readonly string[]): string | null {
  let current: string | null = null;
  for (const to of paths) {
    if (isCurrentPath(pathname, to) && (current === null || to.length > current.length)) current = to;
  }
  return current;
}
